import axios from "axios";

const API_BASE_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/integrations";

export const getDeliveryPlatformType = async (auth0: any): Promise<any> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/delivery`);
    return response.data.deliveryIntegrationType;
  } catch (e) {
    console.error("Error fetching delivery platform type", e);
    throw e;
  }
};
